"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*** node_modules **/
require("picturefill");
require("jquery.easing");
require("slick-carousel");
require("toggle-aria");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
var linker_1 = __importDefault(require("linker"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
var nav_current_1 = __importDefault(require("nav-current"));
require("fit-image");
require("swipe-elem");
require("toggler");
require("expander");
require("toggle-expander");
var local_menu_1 = __importDefault(require("local-menu"));
var stickyer_1 = __importDefault(require("stickyer"));
require("swipe-elem");
require("build-menu");
var menu_1 = require("menu");
require("gallery");
require("lazy-contents");
var top_1 = __importDefault(require("top"));
require('fancybox')($);
require("tab");
hasher_1.default();
$(function () {
    $(window).on('CSSLoad', function () {
        $('body').attr('aria-busy', 'false');
    });
    new nav_current_1.default('#Global');
    new nav_current_1.default('#Local', {
        abs: true,
        escape: [
            '/faculty/social_investigator/',
            '/faculty/secondary/',
            '/faculty/teach_training/',
            '/faculty/fieldworksemi/'
        ],
        add: [
            '/public/culture_lec/'
        ]
    });
    $('#Main h2:not([class])').addClass('mc-H2').wrapInner('<span class="mc-H2_Inner" />');
    var URL = location.pathname;
    var blankDir = ['ams_labo', 'lib', 'general', 'club', 'ca_labo', 'museum', 'joint_labo', 'graduate', 'react', 'new_dept', 'international', 'daisho12', 'oc_spring2019', 'womanstyle', 'movie', 'business_idea'];
    if (URL.search(/^\/ams_labo\//) !== -1) {
        blankDir = ['!ams_labo'];
    }
    else if (URL.search(/^\/lib\//) !== -1) {
        blankDir = ['!lib'];
    }
    else if (URL.search(/^\/general\//) !== -1) {
        blankDir = ['!general'];
    }
    else if (URL.search(/^\/club\//) !== -1) {
        blankDir = ['!club'];
    }
    else if (URL.search(/^\/ca_labo\//) !== -1) {
        blankDir = ['!ca_labo'];
    }
    else if (URL.search(/^\/museum\//) !== -1) {
        blankDir = ['!museum'];
    }
    else if (URL.search(/^\/joint_labo\//) !== -1) {
        blankDir = ['!joint_labo'];
    }
    else if (URL.search(/^\/graduate\//) !== -1) {
        blankDir = ['!graduate'];
    }
    else if (URL.search(/^\/react\//) !== -1) {
        blankDir = ['!react'];
    }
    else if (URL.search(/^\/new_dept\//) !== -1) {
        blankDir = ['!new_dept'];
    }
    else if (URL.search(/^\/international\//) !== -1) {
        blankDir = ['!international'];
    }
    else if (URL.search(/^\/daisho12\//) !== -1) {
        blankDir = ['!daisho12'];
    }
    else if (URL.search(/^\/oc_spring2019\//) !== -1) {
        blankDir = ['!oc_spring2019'];
    }
    else if (URL.search(/^\/womanstyle\//) !== -1) {
        blankDir = ['!womanstyle'];
    }
    else if (URL.search(/^\/movie\//) !== -1) {
        blankDir = ['!movie'];
    }
    else if (URL.search(/^\/business_idea\/01\//) !== -1) {
        blankDir = ['!business_idea'];
    }
    ;
    new linker_1.default({
        icon: {
            blank: 'sw-Blank',
            excel: 'sw-Xls',
            word: 'sw-Doc',
            pdf: 'sw-Pdf'
        },
        blankDir: blankDir
    });
    new menu_1.BuildMenu('#MenuBtn, #SearchBtn');
    tel_handler_1.default();
    slide_scroll_1.default({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll, #MenuBtn, #SearchBtn, .st-Local_Btn, .sw-Fancy, .tea-Tab a, .tea-InnerTab a'
    });
    new local_menu_1.default('#Local');
    new stickyer_1.default({
        'limitElem': '#Wrapper',
        'elemClass': 'st-Header'
    });
    new stickyer_1.default({
        'fixedElem': '.st-Page2Top',
        'limitElem': '#Wrapper',
        'elemClass': 'st-Page2Top',
        'stateClass': 'visible'
    });
    $('.mc-Swipe').swipeElem({
        width: 750
    });
    if (!$('#TopMain').length) {
        $('#Hero').gallery({
            main: 'oth-Hero_Main',
            loader: 'oth-Hero_Loader',
            img: 'oth-Hero_Image',
            play: 'oth-Hero-play',
            next: 'oth-Hero_Image-next',
            current: 'oth-Hero_Image-current'
        });
    }
    ;
    top_1.default();
    $('.sw-Fancy').fancybox();
    $('.sw-AreaFancy').on('click', function (e) {
        e.preventDefault();
        var _href = $(e.currentTarget).attr('href');
        console.log(_href);
        $.fancybox.open({
            href: _href,
            type: 'iframe'
        });
    });
    $('.tea-InnerTab').tab();
    $('.tea-Tab').tab();
});
